import React from 'react';
import Locale from '../../../domain/Locale';
import URL from '../../../domain/URL';
import ProductDomain from '../../../domain/Product';
import Color from '../../../domain/Color';
import Widget from '../../../domain/Widget';
import WidgetLayout from '../../../components/WidgetLayout';
import Console from '../../../components/Console';
import ProductComponent from '../../../components/Product';
import WidgetHeader from '../../../components/WidgetHeader';
import { t, props } from 'tcomb-react';
const doShowBonus = false;
const doShowTimeAgo = false;

@props({
  locale: Locale,
  product: ProductDomain,
  message: t.maybe(t.ReactElement),
  oldPrice: t.maybe(t.Num),
  doShowConsole: t.Bool,
  doReduce: t.Func,
  goBuildOrder: t.Func,
  goPurchase: t.Func,
  themeBgColor: t.maybe(Color),
  themeBtnColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  widget: t.maybe(Widget),
  miniSiteURL: URL
})
export default class ProductWidget extends React.Component {

  constructor(...args) {
    super(...args);
  }

  getWidgetFooterImage() {
    if (!this.props.widget) {
      return null;
    }
    return this.props.widget.footer_image;
  }

  getHeader() {
    return (<WidgetHeader widget={this.props.widget}/>);
  }

  getContent() {
    const {locale, product} = this.props;
    return (
      <div className="product-desktop">
        <div className="large-35 large-pull-right">
          <div className="cell">
            <Console
              doShowConsole={this.props.doShowConsole}
              locale={locale}
              themeBgColor={this.props.themeBgColor}
              themeBtnColor={this.props.themeBtnColor}
              themeBgFontColor={this.props.themeBgFontColor}
              themeBtnFontColor={this.props.themeBtnFontColor}
              message={this.props.message}
              product={product}
              goBuildOrder={this.props.goBuildOrder}
              goPurchase={this.props.goPurchase}
              doReduce={this.props.doReduce}
              oldPrice={this.props.oldPrice}
              doShowTimeAgo={doShowTimeAgo}
              doShowBonus={doShowBonus}
              doShowProductName
              doShowArrowRight={false}/>
          </div>
        </div>
        <div className="large-65 large-pull-left">
          <div className="cell">
            <ProductComponent showDetails={false} locale={locale} product={product} themeBgFontColor={this.props.themeBgFontColor} themeBgColor={this.props.themeBgColor}/>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {locale} = this.props;
    return (
      <WidgetLayout header={this.getHeader()} locale={locale} miniSiteURL={this.props.miniSiteURL} footerImage={this.getWidgetFooterImage()}>
        <div id="product">
          <div className="cols">
            <div className="large-100">
              {this.getContent()}
            </div>
          </div>
        </div>
      </WidgetLayout>
    );
  }
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/route/widget/Product.js
 **/